import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loading from "./Loading";
import { useRecoilValue } from "recoil";
import { AtomScore } from "../store/store";
import axios from "axios";
import Apply from "../pages/Apply";

export default function Popup({
  handlePopup,
  image,
  name,
  id,
  completePopupHanlder,
}) {
  const [userDatas, setUserDatas] = useState({
    nickname: "",
    phone: "",
    privacy: false,
  });

  const formData = new FormData();

  const idealScore = useRecoilValue(AtomScore);
  const navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const changeHanlder = (e) => {
    const { value, name } = e.target;
    if (value.includes("-")) return alert(" '-' 를 빼주세요");
    if (name === "privacy") {
      const checked = e.target.checked;
      return setUserDatas((prev) => ({ ...prev, [name]: checked }));
    }
    setUserDatas((prev) => ({ ...prev, [name]: value }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // 이미지를 Blob으로 다운로드
    // 파일명과 MIME 타입은 실제 상황에 맞게 변경

    if (userDatas.privacy === false) {
      return alert("개인정보이용동의에 체크해주세요.");
    }
    setLoading(true);
    const response = await fetch(image);
    const blob = await response.blob();

    // Blob을 File 객체로 변환
    const file = new File([blob], "image.png", { type: "image/png" });

    const IMP = window.IMP;
    IMP.init(process.env.REACT_APP_IMP_CODE);
    // IMP.certification(param, callback) 호출
    IMP.certification(
      {
        // param
        // 주문 번호
        // pg: process.env.REACT_APP_PG_CODE, //본인인증 설정이 2개이상 되어 있는 경우 필
        merchant_uid: "ORD20180131-0000011",
        // 모바일환경에서 popup:false(기본값) 인 경우 필수
        // PC환경에서는 popup 파라미터가 무시되고 항상 true 로 적용됨
        popup: false,
      },
      function (rsp) {
        // callback

        if (rsp.success) {
          formData.append("image", file);
          formData.append("nickname", name);
          formData.append("card_id", id.toString());
          formData.append("height", idealScore.height);
          formData.append("job", idealScore.job);
          formData.append("degree", idealScore.degree);
          formData.append("family", idealScore.family);
          formData.append("economy", idealScore.economy);
          formData.append("imp_uid", rsp.imp_uid);
          axios
            .post(
              `${process.env.REACT_APP_BASE_URL}/api/admin/ideal_worldcup`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              setLoading(false);
              completePopupHanlder(true);
              handlePopup("close");
            })
            .catch((e) => {
              console.error(e);
              if (e.response.status === 406) alert(e.response.data.message);
              handlePopup("close");
              setLoading(false);
            });
        } else {
          console.error(rsp);
          alert("인증에 실패하셨습니다.");
          setLoading(false);
        }
      }
    );
  };

  const activeLoading = () => {
    if (loading) {
      return <Loading />;
    }
    return;
  };

  return (
    <div className="popup">
      <form className="popup_wrap" onSubmit={submitHandler}>
        <div className="close">
          <AiOutlineClose onClick={() => handlePopup("close")} />
        </div>

        <h3>응모하기</h3>

        <div className="privacy">
          <label htmlFor="privacy">
            <input
              type="checkbox"
              id="privacy"
              name="privacy"
              checked={userDatas.privacy}
              onChange={changeHanlder}
            />
            <span>[개인정보이용동의]</span>
          </label>
          <Link
            to="https://porena.app/privacy/"
            className="detail"
            target="_blank"
          >
            제세히보기
          </Link>
        </div>
        <span className="alert">
          *잘못된 연락처의 기재 및 휴대폰 해지, 정지, 번호 변경 등으로 인한 상품
          미수령에 따른 재발송 및 환불은 불가합니다.
        </span>
        <button type="submit" className="popupBtn">
          본인인증 후 응모하기!
        </button>
      </form>

      {activeLoading()}
    </div>
  );
}
